module.exports = __webpack_public_path__ + "img/onCrane.05832ced.gif";